import { useSplitConfigStore } from '../../stores/splitConfigStore'
import { useUIStore } from '../../stores/uiStore'
import type { MuscleGroup } from '../../types'
import { ANATOMICAL_MUSCLE_ORDER } from '../../utils'
import { CompactVolumeCard } from './CompactVolumeCard'
import { SecondaryMoversToggle, Toggle } from '../ui/secondary-movers-toggle'
import { UnifiedButton } from '../ui/unified-button'

export const VolumeRoutineWidget = () => {
  const { weeklyVolume, weeklyVolumePrimaryOnly, calculateVolume, clearAllData, cycleMode, toggleCycleMode, cycleAssignments } = useSplitConfigStore()
  const { includeSecondaryMovers, toggleSecondaryMovers } = useUIStore()

  // Use the appropriate volume based on toggle state
  const currentVolume = includeSecondaryMovers ? weeklyVolume : weeklyVolumePrimaryOnly

  // Calculate sorted muscle volume data following the exact same pattern as RoutineWidget
  const sortedMuscleVolume = ANATOMICAL_MUSCLE_ORDER.map((muscleGroup) => ({
    muscleGroup,
    weeklySetCount: currentVolume[muscleGroup as keyof typeof currentVolume] || 0,
    dailyBreakdown: {},
    exercises: []
  }))

  const maxVolume = Math.max(...sortedMuscleVolume.map((mv) => mv.weeklySetCount), 1)

  const handleToggleSecondaryMovers = () => {
    toggleSecondaryMovers()
    calculateVolume() // Recalculate volume when toggled
  }

  const handleClearAll = () => {
    clearAllData()
  }

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-medium">
          Volume Breakdown
          {cycleMode && cycleAssignments.length > 0 && (
            <span className="ml-2 text-xs text-muted-foreground">
              ({cycleAssignments.length}-day cycle)
            </span>
          )}
        </h3>
        <div className="flex items-center gap-2">
          <Toggle
            type="cycleMode"
            enabled={cycleMode}
            onToggle={toggleCycleMode}
            size="sm"
            showLabel={true}
            tooltipPosition="bottom"
          />
          <SecondaryMoversToggle
            enabled={includeSecondaryMovers}
            onToggle={handleToggleSecondaryMovers}
            size="sm"
            showLabel={true}
            tooltipPosition="bottom"
          />
          <UnifiedButton
            variant="ghost"
            size="sm"
            onClick={handleClearAll}
            className="text-destructive hover:text-destructive"
          >
            Clear
          </UnifiedButton>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-1 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-8">
        {sortedMuscleVolume.map((volumeData) => (
          <CompactVolumeCard
            key={volumeData.muscleGroup}
            muscleGroup={volumeData.muscleGroup as MuscleGroup}
            sets={volumeData.weeklySetCount}
            maxVolume={maxVolume}
          />
        ))}
      </div>
    </div>
  )
}
